import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

// import "./VolumeCovep.scss";
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByCompetitor } from "../../../services/graphics-service";
import {
  formatGraphicVolumePerConcorrente,
  formatGraphicVolumePerCovep,
} from "../../../utils/formatted-graphic-values";
import { getCompetitors } from "../../../services/competitor-service";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const VolumeConcorrente = () => {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const [graphicValues, setGraphicValues] = useState({});
  const [competitorList, setCompetitorList] = useState([]);
  const [selectedCompetitor, setSelectedCompetitor] = useState([]);
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  useEffect(() => {
    async function getCompetitorsList() {
      const result = await getCompetitors(accessToken);

      if (!result) return;

      setCompetitorList(
        result.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        )
      );
    }
    getCompetitorsList();
  }, [accessToken]);

  const getGraphicData = async () => {
    const result = await getVolumeByCompetitor(
      accessToken,
      dateValue[0],
      dateValue[1],
      selectedCompetitor
    );
    setGraphicValues(result.data);
    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por concorrente</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher pelo menos um concorrente para gerar o gráfico.</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
        <div>
          <FormControl style={{ width: "272px" }}>
            <InputLabel id="demo-multiple-checkboxx-label">
              Concorrentes
            </InputLabel>
            <Select
              multiple
              value={selectedCompetitor}
              onChange={(e) => setSelectedCompetitor(e.target.value)}
              input={<OutlinedInput label="Concorrentes" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {competitorList.map((item) => (
                <MenuItem key={`${item.name} - ${item.id}`} value={item.id}>
                  <Checkbox
                    checked={selectedCompetitor.indexOf(item.id) > -1}
                  />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <>
          {graphicValues.map((el, index) => {
            return (
              <div key={index} className="graphic-container-multiple">
                <h1>{el.concorrente}</h1>
                <LineChart values={formatGraphicVolumePerConcorrente(el)} />
              </div>
            );
          })}
        </>
      )}
    </main>
  );
};

export default VolumeConcorrente;
